<template>
  <div>
    <Titel title="News" /><br>
    <Nachricht v-for="Nachricht in News" :key="Nachricht.Titel" :title="Nachricht.Titel" :date="Nachricht.Datum" :text="Nachricht.Text" />
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import Titel from '@/components/Titel'
import Nachricht from '@/components/Nachricht'

export default {
  name: 'News',

  components: {
    Titel,
    Nachricht
  },

  data () {
    return {
      News: []
    }
  },

  mounted: function () {
    firebase.database().ref('News').on('value', snap => {
      this.News = []
      for (var News in snap.toJSON()) {
        if (!snap.child(News + '/anzeigen').exists() || snap.child(News + '/anzeigen').val() === true) {
          this.News.push({
            Titel: snap.child(News + '/Titel').val(),
            Datum: snap.child(News + '/Datum').val(),
            Text: snap.child(News + '/Text').val()
          })
        }
      }
      this.News.sort(function (News1, News2) {
        var Datum1 = new Date(News1.Datum)
        var Datum2 = new Date(News2.Datum)
        if (Datum1.getYear() < Datum2.getYear()) return 1
        if (Datum1.getYear() > Datum2.getYear()) return -1
        if (Datum1.getMonth() < Datum2.getMonth()) return 1
        if (Datum1.getMonth() > Datum2.getMonth()) return -1
        if (Datum1.getDate() < Datum2.getDate()) return 1
        if (Datum1.getDate() > Datum2.getDate()) return -1
        return 0
      })
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/News.vue